module.exports = __webpack_public_path__ + "assets/img/overlay-login-back.498b3456.png";